import React, { Fragment } from "react";
import "./style.css";

const Details = ({ data }) => {
  return (
    <Fragment>
      {data?.[0]?.activityDetails?.description?.details?.length > 0 &&
        <>
          <h5 className="feature-hdng text-center mt-5 mb-5">Details</h5>
          <div className="details mb-5">
            {data?.[0]?.activityDetails?.description?.details?.map(item => <li className="detail-list">{item}</li>)}
          </div>
        </>
      }
    </Fragment>
  )
}

export default Details;
